import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import CSVReader, { IFileInfo } from 'react-csv-reader';

import IconButton from '../../components/common/Buttons/IconButton';

import { CSV_IMAGE } from '../../utils/constants/images';
import { SAMPLE_CSV_URL } from '../../utils/constants';

import { useCommonStore } from '../../stores/commonStore';

import { convertCSVtoFSNData, validateGoLiveCSV } from '../../utils/fileUtils';
import { generateRandomString } from '../../utils/commonUtils';

import { CSVData } from '../../types/common';

const CSVImport = () => {
    const history = useHistory();
    const setFsns = useCommonStore((state) => state.setGoLiveFsns);
    const setActiveProduct = useCommonStore((state) => state.setActiveFSN);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);
    const [inputKey, setInputKey] = useState('');

    const handleFileChange = (data: CSVData[], fileInfo: IFileInfo) => {
        //TODO: need to fix this
        const validation: { valid: boolean; error?: string } = validateGoLiveCSV(data, fileInfo);
        setInputKey(generateRandomString());
        if (!validation.valid && validation.error) {
            return setToastMessage({ type: 'error', message: validation.error }, 2000);
        }
        const newFsns = convertCSVtoFSNData(data);
        setFsns(newFsns);

        if (!newFsns.length) {
            setToastMessage({ type: 'error', message: 'All Models Visual QC has failed . please check' }, 1000);
            return;
        }

        if (newFsns.length) {
            setActiveProduct(newFsns[0].fsn);
        }
    };

    const handleGoBack = () => {
        history.goBack();
    };

    return (
        <div className="h-full mx-auto p-8 flex items-center justify-center flex-col relative">
            <div className="absolute left-10 top-10">
                <IconButton label="Go Back" onClick={handleGoBack} color="" borderColor="gray" textColor="gray">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.3327 5.33317H3.21935L6.94602 1.6065L5.99935 0.666504L0.666016 5.99984L5.99935 11.3332L6.93935 10.3932L3.21935 6.6665H11.3327V5.33317Z" fill="#111112" />
                    </svg>
                </IconButton>
            </div>
            <div className="lg:w-1/2 sm:w-full text-center custom-dashed-border lg:p-36 md:p-20 p-10 relative">
                <div key={inputKey}>
                    <CSVReader
                        cssClass="absolute left-0 right-0 top-0 bottom-0 z-10"
                        cssInputClass="w-full h-full opacity-0 cursor-pointer"
                        onFileLoaded={handleFileChange}
                        parserOptions={{ header: true, dynamicTyping: true, transformHeader: (header) => header.toLowerCase().replace(/\W/g, '_') }}
                    />
                </div>
                <img src={CSV_IMAGE} className="block mx-auto" alt="" />
                <h5 className="text-xl font-medium text-black mt-5">
                    Drag and Drop an .CSV file, or <span className="text-blue-600 cursor-pointer">Browse</span>
                </h5>
                <p className="text-base mt-1 text-gray-400">
                    File should have single column of FSNs with no header.{' '}
                    <a href={SAMPLE_CSV_URL} className=" relative  z-20 text-blue-600 underline" target="_blank" rel="noreferrer">
                        Sample Format here
                    </a>
                </p>
            </div>
        </div>
    );
};

export default React.memo(CSVImport);
